import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { UploadFileRequest } from '@cashier/cashier-api-model';
import { AddDataUploadedPayload } from '@cashier/cashier-model';

import {
  uploadFileFailure,
  uploadFileStart,
  uploadFileSuccess,
} from './fileUploading.slice';

export const uploadFileEpic = (action$, state$, { Api }) =>
  action$.pipe(
    ofType(uploadFileStart.type),
    switchMap((action: { payload: UploadFileRequest }) =>
      Api.uploadFile({
        data: action.payload.data,
        transactionId: action.payload.transactionId,
      }).pipe(
        map((link: string) =>
          uploadFileSuccess({ name: action.payload.data.name, link }),
        ),
        catchError((err) => of(uploadFileFailure(err))),
      ),
    ),
  );

export const uploadFile = (
  data: AddDataUploadedPayload,
  transactionId: string,
) => ({
  type: uploadFileStart.type,
  payload: { data, transactionId },
});
